interface CaretRect {
  left: number
  top: number
  bottom: number
}

interface VisibleRect extends CaretRect {
  width: number
  height: number
}

/** Coordinates inside a CSS-owned, safe-area/keyboard-aware visible frame. */
export function placeCaretPopover(
  caret: CaretRect,
  frame: VisibleRect,
  content: { width: number; height: number },
): { left: number; top: number; maxHeight: number } {
  const above = Math.max(0, Math.min(frame.height, caret.top - frame.top))
  const below = Math.max(0, Math.min(frame.height, frame.bottom - caret.bottom))
  const opensAbove = content.height > below && above > below
  const maxHeight = opensAbove ? above : below
  const height = Math.min(content.height, maxHeight)
  return {
    left: Math.max(0, Math.min(caret.left - frame.left, frame.width - content.width)),
    top: Math.max(0, Math.min(
      opensAbove ? caret.top - frame.top - height : caret.bottom - frame.top,
      frame.height - height,
    )),
    maxHeight,
  }
}
